import { classNames } from "../../utils/helpers"
import Box from "../Box"

export interface RatingProps {
  /** Number of stars given, default is 5 */
  value?: number
  /** The amount of stars to render, default is 5 */
  amount?: number
  /** Should be a TailwindCss supported color and format */
  fillColor?: string
  /** Should be a TailwindCss supported color and format */
  emptyColor?: string
  /** Use it to overwrite the default container styles, you may need to make some styles !important */
  className?: string
}

const Rating = ({
  amount = 5,
  fillColor,
  emptyColor,
  className,
  value = 5
}: RatingProps) => (
  <Box className='flex'>
    {Array.from({ length: amount }).map((i, idx) =>
      idx < value ? (
        <svg
          key={idx}
          aria-hidden="true"
          className={classNames(
            "w-5 h-5",
            fillColor || "text-yellow-500",
            className
          )}
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>{idx} star</title>
          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
        </svg>
      ) : (
        <svg
          key={idx}
          aria-hidden="true"
          className={classNames(
            emptyColor || "text-gray-200",
            "w-5 h-5",
            className
          )}
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>{idx} star</title>
          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
        </svg>
      )
    )}
  </Box>
)

export default Rating
